import { useQuery } from '@tanstack/react-query'

import type { Moment } from 'moment'
import useAlertService from '../services/AlertService'
import { AlertModel } from '@/app/models/alert/alertModel'

type UseQueryAlertsParams = {
  companyId: string
  drivers: Array<string> | null
  dateFrom: Moment | string
  dateTo: Moment | string
  isDriver: boolean
  upcoming: boolean
  onlyVisible: boolean
  enabled?: boolean
}

export function useQueryAlerts({
  companyId,
  drivers,
  dateFrom,
  dateTo,
  isDriver,
  upcoming,
  onlyVisible,
  enabled = true,
}: UseQueryAlertsParams) {
  const alertService = useAlertService()

  return useQuery<Array<AlertModel>>({
    queryKey: [
      'alerts',
      companyId,
      drivers,
      typeof dateFrom === 'string' ? dateFrom : dateFrom.format('YYYY-MM-DD'),
      typeof dateTo === 'string' ? dateTo : dateTo.format('YYYY-MM-DD'),
      isDriver,
      upcoming,
      onlyVisible,
    ],
    queryFn: async () => {
      return await alertService.getAlerts({
        companyId,
        drivers,
        dateFrom,
        dateTo,
        isDriver,
        upcoming,
        onlyVisible,
        showLoading: false, // React Query handles loading state
      })
    },
    enabled: enabled && !!companyId,
    staleTime: 30000, // 30 seconds
  })
}

